import { useGSAP } from "@gsap/react";
import { View } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import gsap from "gsap";
import { useEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import { animateWithGsapTimeline } from "../utils/animations";
import ModelView from './ModelView';
import GlassButton from "./ui/GlassButton";

const tokenNames = [
  'GECKO', 'TIGER', 'RHINO', 'STEGO', 'CHEETO', 'BISON', 'DINO', 'MOA', 'WOOLY', 'SABRE',
  'QUAGGA', 'PANDA', 'PTERAN', 'THYLAC', 'AUROCH', 'IVORY', 'PANG', 'CONDOR', 'BAIJI', 'GLYPTO',
  'MEGAL', 'DIRE', 'QUETZAL', 'LYNX', 'SAURO', 'OKAPI', 'KAKAPO', 'VAQUITA', 'GORILLA', 'RED\u00a0WOLF',
  'TORTOISE', 'OWL', 'MANATEE', 'GIBBON', 'RIVER', 'AMUR', 'ADDAX', 'TUATARA', 'IBIS', 'ELEPHANT',
  'LEMUR', 'DODO', 'HARPY', 'WOLF', 'SUN\u00a0BEAR', 'ORCA', 'PIKA', 'SHARK', 'MYNAH', 'CAMEL'
];

const Model = () => {
  const [size, setSize] = useState('size1'); // Default size
  const [model, setModel] = useState({    
  });

  const [activeIndex, setActiveIndex] = useState(0); // Default to Zero-Coin

  // camera control for the model view
  const cameraControlSmall = useRef();
  const cameraControlLarge = useRef();

  // model
  const small = useRef(new THREE.Group());
  const large = useRef(new THREE.Group());

  // rotation
  const [smallRotation, setSmallRotation] = useState(0);
  const [largeRotation, setLargeRotation] = useState(0);

  const tl = gsap.timeline();

  useEffect(() => {
    if (size.startsWith('size')) {
      animateWithGsapTimeline(tl, large, largeRotation, '#view1', '#view2', '#view3', {
        transform: 'translateX(-100%)',
        duration: 2
      });
    } else {
      animateWithGsapTimeline(tl, small, smallRotation, '#view3', '#view2', '#view1', {
        transform: 'translateX(0)',
        duration: 2
      });
    }
  }, [size]);

  useGSAP(() => {
    gsap.to('#heading', { y: 0, opacity: 1 });
  }, []);

  const handleTokenClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <section id="modelViewSection" className="common-padding">
      <div className="screen-max-width flex">
        {/* Title on the left */}
        <h1 id="heading" className="section-heading" style={{ transform: 'translateX(-275px)' }}>
          <p>Explore Our Coins</p>
          <p>& Tokens</p>
        </h1>
        
        <div className="flex w-full">
          {/* Model viewer area - 3/5 width */}
          <div className="w-3/5">
            <div className="w-full h-[65vh] md:h-[80vh] overflow-hidden relative mb-2">
              <ModelView
                activeIndex={activeIndex}
                groupRef={large}
                gsapType="view"
                controlRef={cameraControlLarge}
                setRotationState={setSmallRotation}
                item={model}
                size={size}
              />
              <Canvas
                className="w-full h-full"
                style={{
                  position: 'fixed',
                  top: -25,
                  bottom: -25,
                  left: 0,
                  right: 0,
                  overflow: 'hidden'
                }}
                eventSource={document.getElementById('root')}
              >
                <View.Port />
              </Canvas>
            </div>

            {/* Zero-Coin section below model */}
            <div className="mx-auto w-full">
              <p
                className="text-lg font-bold text-center mb-2 -mt-20"
                style={{ marginLeft: '-195px' }}
              >
                native to Zero-blockchain.xyz
              </p>
              <div className="flex justify-center mt-5 mb-5 relative z-20">
                <GlassButton
                  onClick={() => handleTokenClick(0)}
                  variant={activeIndex === 0 ? "cyan" : "gray"}
                  size="md"
                  className="ml-[-192px]"
                >
                  Zero-Coin
                </GlassButton>
              </div>
              <p className="text-sm font-light text-center mb-5 mt-0">{model.title}</p>
            </div>
          </div>
          
          {/* Token grid on right - 5 columns with wider container */}
          <div className="w-full md:w-1/2 flex flex-col items-center relative z-20" style={{ marginRight: '-150px' }}>
            <h2 className="text-xl md:text-2xl font-bold text-center mb-6 text-cyan-400 w-full">
              Zero-bank ERC-20 Tokens
            </h2>
            <div className="grid grid-cols-5 gap-6 p-1 w-full justify-items-center">
              {tokenNames.map((label, index) => (
                <GlassButton
                  key={index}
                  onClick={() => handleTokenClick(index + 1)}
                  variant={activeIndex === index + 1 ? "cyan" : "gray"}
                  size="sm"
                  className="w-full"
                >
                  <span className="text-[9px] font-bold tracking-tight uppercase">
                    {label}
                  </span>
                </GlassButton>
              ))}
            </div>
          </div>
        </div>
      </div>      
    </section>
  );
};

export default Model;
